import {z} from 'zod'
import {Controller, useFormContext} from 'react-hook-form'
import {Grid, GridItem} from '@/components/ui/grid-atoms/GridAtoms'
import {InputText} from '@/components/commons/input-text/InputText'
import {MedicalReportFieldsSchema} from '../../formSchemas'
import {InputPhone} from '@/components/commons/input-phone/InputPhone'
import {useTranslation} from '@/translations/i18n'

const ReferenceContactFieldsSchema = MedicalReportFieldsSchema.pick({
    referenceContactFirstName: true,
    referenceContactLastName: true,
    referenceKinship: true,
    referencePhone: true
})
type ReferenceContactFieldsSchema = z.infer<typeof ReferenceContactFieldsSchema>

export const ReferenceContactFields = () => {
    const {t} = useTranslation()
    const {
        register,
        control,
        setValue,
        formState: {errors}
    } = useFormContext<ReferenceContactFieldsSchema>()

    return (
        <Grid columns={2} columnGap={6} rowGap={4}>
            <GridItem spanColumn={1}>
                <InputText
                    type="text"
                    label={t('commons:last_name_label')}
                    placeholder={t('medical_records:insert_info')}
                    errorMessage={errors.referenceContactLastName?.message}
                    maxLength={254}
                    {...register('referenceContactLastName')}
                />
            </GridItem>
            <GridItem spanColumn={1}>
                <InputText
                    type="text"
                    label={t('commons:first_name_label')}
                    placeholder={t('medical_records:insert_info')}
                    errorMessage={errors.referenceContactFirstName?.message}
                    maxLength={254}
                    {...register('referenceContactFirstName')}
                />
            </GridItem>
            <GridItem spanColumn={1}>
                <InputText
                    type="text"
                    label={t('medical_records:kinship')}
                    placeholder={t('medical_records:insert_info')}
                    errorMessage={errors.referenceKinship?.message}
                    maxLength={254}
                    {...register('referenceKinship')}
                />
            </GridItem>
            <GridItem spanColumn={1}>
                <Controller
                    control={control}
                    name="referencePhone"
                    render={({field}) => (
                        <InputPhone
                            fullWidth
                            placeholder={t('medical_records:insert_info')}
                            label={t('commons:mobile_phone')}
                            onCallingCountryChangeCb={() => setValue('referencePhone', '')}
                            errorMessage={errors.referencePhone?.message}
                            onChange={value => field.onChange(value)}
                        />
                    )}
                />
            </GridItem>
        </Grid>
    )
}
